import type { ReactNode } from "react";
import classNames from "classnames";

export interface CheckoutFormSectionProps {
  children: ReactNode;
  className?: string;
}

export const CheckoutFormSection = ({
  className,
  children,
}: CheckoutFormSectionProps) => (
  <div
    className={classNames(
      "border-secondary-200 flex flex-col empty:hidden",
      className,
    )}
  >
    {children}
  </div>
);
